import { RouteRecordName } from "vue-router";

export const PUBLIC_RT: RouteRecordName[] = ["ForgetPwd", "Login"];
